/**
 * propertyDisplay.ts — presentación del nombre de propiedad.
 *
 * Round 2026-06-28: el owner pidió que el nombre de la propiedad SIEMPRE
 * se muestre en MAYÚSCULAS en toda la interfaz (un humano reconoce mejor
 * "MIRAMAR 1007-B" que el id corto o el case original inconsistente).
 *
 * Reglas de uso:
 *   - Es un helper de SOLO PRESENTACIÓN. NO modifica el dato persistido
 *     (la base de datos conserva la capitalización original — 100% reversible:
 *     borrar este helper revierte todo).
 *   - Usar ÚNICAMENTE al renderizar texto visible al usuario (celdas de
 *     tabla, labels de Select, tags, títulos, tooltips, cards).
 *   - NO usar en lógica de búsqueda / filtro / orden (rompería el matching
 *     contra el dato real) ni en construcción de exportaciones (xlsx) o
 *     payloads que se mandan al backend — esos deben conservar el dato crudo.
 *   - El `value`/`key` de un <Select.Option> NUNCA debe pasar por aquí: el
 *     formulario persiste el id/valor real, no el label visible.
 *
 * Acepta nullish y devuelve "" para que el caller conserve su propio
 * fallback: `formatPropertyName(x.nombre) || "—"`.
 */
export function formatPropertyName(nombre?: string | null): string {
  return nombre ? String(nombre).toUpperCase() : "";
}

/**
 * Variante para listas de nombres de propiedad (ej. el array
 * `propiedades: string[]` que devuelven los endpoints de usuarios).
 * Mapea cada elemento por `formatPropertyName`.
 */
export function formatPropertyNames(nombres?: (string | null | undefined)[] | null): string[] {
  return Array.isArray(nombres) ? nombres.map((n) => formatPropertyName(n)) : [];
}
